import RequestPageTwo from "./RequestPageTwo";

const InternalRetreatOrg = () => {
    return (
        <RequestPageTwo title="Internal Retreat Organizer"
            fetchUrl="/get-internal-retreat-organiser-registrations"
            editEndpoint="update-internal-retreat-organiser-registrations"
            deleteEndpoint="internal-retreat-organiser-registrations"
            statusEndpoint="internal-retreat-organiser-registrations" />
    );
}

export default InternalRetreatOrg;
